/**
* Created by qinlili on 2022-01-28.
*/
<template>
  <div
    v-show="path === $route.path"
    :class="['sy-bottom-fixed-wrap', isMall ? 'mall' : '', pageClass]">
    <div class="sy-bottom-fixed-wrap-left">
      <slot name="special"></slot>
    </div>
    <div class="sy-bottom-fixed-wrap-right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { TAB_PAGE_FRAME_STORAGE_KEY } from '../layout-tab/constans'
  export default {
    name: 'index',
    data () {
      return {
        id: null,
        isMall: window.fe.project === 'mall',
        pageFrame: localStorage.getItem(TAB_PAGE_FRAME_STORAGE_KEY),
        path: this.$route.path,
        pageClass: 'sy-bottom-fixed-wrap-' + Date.now()
      }
    },
    watch: {
      '$route.path': {
        handler: function (newVal) {
          if (newVal === this.path) {
            this.$nextTick(() => {
              let node = document.querySelector(`.${this.pageClass}`)
              this.id = 'bottom_fixed_' + Date.now()
              node.id = this.id
              if (this.isMall) {
                let container = document.querySelector('.sy-bottom-fixed-parent')
                container.appendChild(node)
              }
              let syContainer = document.querySelector('.sy-container')
              if (syContainer && syContainer.offsetWidth === 1200) {
                node.style.width = '1200px'
                node.style.right = 'calc(50% - 600px)'
              }
              if (window.fe.fixedBottom) {
                window.fe.fixedBottom.push({
                  key: 'bottomFixed',
                  height: node.offsetHeight
                })
              }
            })
          }
        },
        immediate: true
      }
    },
    mounted() {
      
    },
    beforeDestroy () {
      setTimeout(() => {
        let container = document.querySelector('.sy-bottom-fixed-parent')
        let node = document.querySelector('#' + this.id)
        if (node) {
          container.removeChild(node)
          if (window.fe.fixedBottom) {
            window.fe.fixedBottom = window.fe.fixedBottom.filter(ele => ele.key !== 'bottomFixed')
          } 
        }
      })
    }
  }
</script>

<style scoped lang="scss">
  .sy-bottom-fixed-wrap{
    &.mall{
      position: sticky;
    }
    position: fixed;
    bottom: 0;
    right: 0;
    background-color: #fff;
    border: 1px solid #D6DFFF;
    box-shadow: 0 0 8px rgba(57, 121, 201, 0.14);
    z-index: 1210;
    // width: calc(100% + 32px);
    // margin-left: -16px;
    width: 100%;
    margin-left: 0;
    min-height: 56px;
    box-sizing: border-box;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .sy-bottom-fixed-wrap-left{
      flex: 2;
    }
    .sy-bottom-fixed-wrap-right{
      flex: 3;
      text-align: right;
    }
  }
</style>
